import React, {useContext, useEffect, useState} from "react";
import { getCustomerProfile } from "../../api/custAccountApi";
import { LoadingContext } from "./LoadingProvider";
import { useCommonContext } from "./CommonProvider";
import { MESSAGE, MESSAGE_TYPE } from "../../constants/messages";
import { getErrorCode } from "../../utils/errors";
import analytics from "../../utils/analytics";
import thdCustomer from "@thd-olt-global/thd-customer";
import { setUrl, validateResponse } from "../../utils";
import { API_URLS } from "../../constants/urls";

export const AccountContext = React.createContext({});

const AccountProvider = (props) => {
  const [stale, setStaleState] = useState(true)
  const [account, setAccount] = useState(null)

  const { children } = props;
  const { showLoading, hideLoading } = useContext(LoadingContext);
  const { addAlert } = useCommonContext();

  useEffect(() => {
    if (stale) {
      showLoading(true)
      if(!thdCustomer.isLoggedIn) {
        setUrl("", API_URLS.SIGNIN)
        return
      }
      getCustomerProfile().then(({ response, error }) => {
        if (response) {
          setStaleState(false)
          setAccount(response.data.account)
        } else {
          const errorCode = getErrorCode(error);
          // Still need pageSection and message, according to spec
          const pageData = {
            error: [{
              type: "error",
              displayType: "page",
              code: errorCode,
              pageSection: "security and sign in",
              message: MESSAGE.SOMETHING_WENT_WRONG
            }]
          };
          analytics.addPageData(pageData);
          addAlert(MESSAGE_TYPE.DANGER, MESSAGE.SOMETHING_WENT_WRONG);
        }
        hideLoading();
      })
    }
  }, [stale])

  const context = {
    stale,
    setStale: () => setStaleState(true),
    account,
    email: account?.profile?.emailId
  }

  if(account) {
    return (
        <AccountContext.Provider value={context}>
          {children}
        </AccountContext.Provider>
    )
  }

  return null
}

export const useCustomerAccount = () => {
  const context = useContext(AccountContext);

  if (context === undefined) {
    throw new Error("useCustomerAccount context need to be used within Account Context Provider");
  }

  return context;
};

export default AccountProvider;
